<template>
    <div id="content">
        <div class="imprint container">
            <div class="imprint-above">
                <div class="imprint-above--title">
                    <span>{{ $tc('imprint', 2) }}</span>
                </div>
                <div class="imprint-above--info">
                    <div class="imprint-above--info-left">
                        <strong>{{ $t('footer_imprint.company_name') }}</strong>
                        <strong>Website</strong>
                        <strong>{{ $t('footer_imprint.first_&_last_name') }}</strong>
                        <strong>{{ $t('address') }}</strong>
                        <strong>{{ $t('footer_imprint.court') }}</strong>
                        <strong>{{ $t('footer_imprint.company_registr_number') }}</strong>
                        <strong>{{ $t('footer_imprint.sales_tax_liability') }}</strong>
                        <strong>{{ $t('footer_imprint.tax_id') }}</strong>
                    </div>
                    <div class="imprint-above--info-right">
                        <span>{{ coreInfo.shop_company_info.name || '-' }}</span>
                        <span>{{ coreInfo.shop_company_info.website || '-' }}</span>
                        <span>{{ coreInfo.shop_company_info.shop_owner || '-' }}</span>
                        <span>{{ coreInfo.owner.street }}, {{ coreInfo.owner.zip }},  {{ coreInfo.owner.country.name }}</span>
                        <span>{{ coreInfo.shop_company_info.court || '-' }}</span>
                        <span>{{ coreInfo.shop_company_info.company_number || '-' }}</span>
                        <span>{{ $tc('tax_obligation', +coreInfo.shop_company_info.tax_obligation) }}</span>
                        <span>{{ coreInfo.shop_company_info.tax_id || '-' }}</span>
                    </div>
                </div>
            </div>
            <div class="imprint-below">
                <div class="imprint-below--title">
                    <span>{{ $t('footer_imprint.additional_info') }}</span>
                </div>
                <div class="imprint-below--info">
                    <div class="imprint-below--info-left">
                        <strong>{{ $tc('telephone', 1) }}</strong>
                        <strong>{{ $t('fax') }}</strong>
                        <strong>{{ $t('email') }}</strong>
                    </div>
                    <div class="imprint-below--info-right">
                        <span>{{ coreInfo.contact_phone || '-' }}</span>
                        <span>{{ coreInfo.contact_fax || '-' }}</span>
                        <span v-if="coreInfo.contact_email">
                            <a :href="`mailto:${coreInfo.contact_email}`">{{ coreInfo.contact_email }}</a>
                        </span>
                        <span v-else>-</span>
                        <span v-if="coreInfo.custom_description" style="white-space: pre">{{ coreInfo.custom_description }}</span>
                    </div>
                </div>
            </div>
        </div>
        <powered-by v-if="hasPoweredBy"/>
    </div>
</template>

<script>
  import PoweredBy from '../components/PoweredBy.vue';

  export default {
    computed: {
      coreInfo() {
        return this.$store.getters.CORE_PARAMS;
      },
    },
    components: {
      PoweredBy,
    },
  };
</script>

<style lang="scss">
    @import "../scss/variables";

    .imprint {
        padding: 0;
        width: 100%;

        &-below,
        &-above {
            border: 1px solid var(--bg-secondary-color-dark);
            border-radius: $border-radius;
            overflow: hidden;
            background-color: var(--bg-color);
        }

        &-below {
            margin-top: 20px;
        }

        strong,
        span {
            display: block;
            font-size: 13px;
            margin-bottom: 15px;
        }


        &-above--title,
        &-below--title {
            span {
                background-color: var(--bg-secondary-color-dark);
                padding: 10px 15px;
                font-size: 14px;
            }
        }

        &-above--info,
        &-below--info {
            display: grid;
            grid-template-columns: 3fr 5fr;
            grid-column-gap: 20px;
            letter-spacing: 0.02em;

            &-left {
                justify-self: flex-end;
                text-align: end;
            }

            &-right {

            }
        }
    }
</style>